export function compare(source, target) {
    return `${source}`.toLowerCase().includes(`${target}`.toLowerCase());
}
export function isValueInCard(card, value, by) {
    if (by) {
        return compare(card[by] || "", value);
    }
    else {
        return (compare(card.label || "", value) ||
            compare(card.description || "", value));
    }
}
//# sourceMappingURL=search.js.map